import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";

function Logos() {
  return (
    <div className="portfolio-logos">
      <div className="row">
        <div className="column">
          <LazyLoadImage
            src="images/portfolio/logos/bday.png"
            style={{ width: "100%" }}
            alt="Birthday invitation flyer"
              effect="blur"
          />
          <LazyLoadImage
            src="images/portfolio/logos/American Hub.png"
            style={{ width: "100%" }}
            alt="American Hub logo"
              effect="blur"
          />
        </div>

        <div className="column">
          <LazyLoadImage
            src="images/portfolio/logos/Chenin Blanc.png"
            style={{ width: "100%" }}
            alt="Chenin Blanc Logo"
              effect="blur"
          />
          <LazyLoadImage
            src="images/portfolio/logos/Clover Star Movers 111.png"
            style={{ width: "100%" }}
            alt="Clover Star Movers Logo"
              effect="blur"
          />
        </div>

        <div className="column">
          <LazyLoadImage
            src="images/portfolio/logos/delzer home inspection.png"
            style={{ width: "100%" }}
            alt="Dezler Home inspection Logo"
              effect="blur"
          />
          <LazyLoadImage
            src="images/portfolio/logos/DAN.png"
            style={{ width: "100%" }}
            alt="DAN logo"
              effect="blur"
          />
          <LazyLoadImage
            src="images/portfolio/logos/gobu1.png"
            style={{ width: "100%" }}
            alt="Gobu App Logo"
              effect="blur"
          />
        </div>

        <div className="column">
          <LazyLoadImage
            src="images/portfolio/logos/gobu.png"
            style={{ width: "100%" }}
            alt="Gobu app logo"
              effect="blur"
          />
          <LazyLoadImage
            src="images/portfolio/logos/cafco.png"
            style={{ width: "100%" }}
            alt="cafco logo"
              effect="blur"
          />
        </div>
      </div>
    </div>
  );
}

export default Logos;
